import { beginCell, Cell, toNano } from '@ton/core';

const TON_AMOUNT_PATTERN = /^(?:0|[1-9]\d*)(?:\.\d{1,9})?$/;
const INVALID_AMOUNT_MESSAGE = 'Enter a valid TON amount.';

export const buildCommentPayload = async (comment) => {
	const trimmed = comment.trim();
	if (!trimmed) return undefined;
	const cell = beginCell()
		.storeUint(0, 32)
		.storeStringTail(trimmed)
		.endCell();
	return cell.toBoc().toString('base64');
};

export const parseDonationAmount = (amountTon) => {
	const amountText = String(amountTon).trim();
	if (!TON_AMOUNT_PATTERN.test(amountText)) {
		throw new Error(INVALID_AMOUNT_MESSAGE);
	}

	const nanoAmount = toNano(amountText);
	if (nanoAmount <= 0n) {
		throw new Error(INVALID_AMOUNT_MESSAGE);
	}

	return nanoAmount.toString();
};

export const buildDonationTransaction = async ({ address, amountTon, comment, from }) => {
	const payload = await buildCommentPayload(comment);
	return {
		validUntil: Math.floor(Date.now() / 1000) + 360,
		...(from ? { from } : {}),
		messages: [
			{
				address,
				amount: parseDonationAmount(amountTon),
				...(payload ? { payload } : {}),
			},
		],
	};
};

export const getSignedBocHash = (boc) => {
	if (!boc) return undefined;
	try {
		return Cell.fromBase64(boc).hash().toString('hex');
	} catch {
		return undefined;
	}
};

export const buildTonviewerUrl = (hash) => {
	if (!hash) return undefined;
	return `https://tonviewer.com/transaction/${hash}`;
};
